(function () {
    window.KocotAnimations = window.KocotAnimations || {};

    var googleMapsPromise = null;
    var mapStyles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}];

    function loadGoogleMaps(apiKey) {
        if (window.google && window.google.maps) {
            return Promise.resolve(window.google.maps);
        }

        if (googleMapsPromise) {
            return googleMapsPromise;
        }

        googleMapsPromise = new Promise(function (resolve, reject) {
            var existingScript = document.getElementById('google-map-js-embed');

            if (existingScript) {
                existingScript.addEventListener('load', function () {
                    resolve(window.google.maps);
                });
                existingScript.addEventListener('error', reject);
                return;
            }

            var script = document.createElement('script');

            script.id = 'google-map-js-embed';
            script.async = true;
            script.src = 'https://maps.google.com/maps/api/js?key=' + encodeURIComponent(apiKey);
            script.addEventListener('load', function () {
                resolve(window.google.maps);
            });
            script.addEventListener('error', reject);

            document.head.appendChild(script);
        });

        return googleMapsPromise;
    }

    function initGoogleMap(section) {
        if (!section || section.dataset.mapInitialized === 'true') {
            return;
        }

        var apiKey = section.dataset.mapApiKey;
        var address = section.dataset.mapAddress;
        var mapElement = section.querySelector('.map-body');

        if (!apiKey || !address || !mapElement) {
            return;
        }

        section.dataset.mapInitialized = 'true';

        loadGoogleMaps(apiKey).then(function () {
            var geocoder = new google.maps.Geocoder();

            geocoder.geocode({ address: address }, function (results, status) {
                if (status !== 'OK' || !results[0]) {
                    section.dataset.mapInitialized = 'false';
                    return;
                }

                var position = results[0].geometry.location;
                var map = new google.maps.Map(mapElement, {
                    zoom: parseInt(section.dataset.mapZoom, 10) || 15,
                    center: position,
                    styles: mapStyles,
                });
                var marker = new google.maps.Marker({
                    map: map,
                    position: position,
                    icon: {
                        url: section.dataset.mapPinUrl,
                        scaledSize: new google.maps.Size(39, 47),
                        anchor: new google.maps.Point(19.5, 47),
                    },
                });
                var infoWindow = new google.maps.InfoWindow({
                    content: section.dataset.mapInfo || address,
                });

                marker.addListener('click', function () {
                    infoWindow.open(map, marker);
                });
            });
        }).catch(function () {
            section.dataset.mapInitialized = 'false';
        });
    }

    function observeMap(section) {
        if (!('IntersectionObserver' in window)) {
            initGoogleMap(section);
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) {
                    return;
                }

                initGoogleMap(section);
                observer.unobserve(section);
            });
        }, {
            rootMargin: '150px 0px',
            threshold: 0,
        });

        observer.observe(section);
    }

    window.KocotAnimations.initMaps = function () {
        document.querySelectorAll('[data-map]:not([data-map-observed="true"])').forEach(function (section) {
            section.dataset.mapObserved = 'true';
            observeMap(section);
        });
    };
})();
